export const getFileName = (name: string | undefined) => name?.split('.').slice(0, -1).join('.') ?? '';
